import VueRouter from 'vue-router';
import Vue from 'vue';
import { CheeersRouteConfig } from '@/config/routes';
import { CheeersConfig } from '@/config';
import { Authentication } from '@/bootstrap/heplers/authentication';
import { AxiosError } from 'axios';

export default function BootstrapRouter(
  routes: CheeersRouteConfig[],
  config: CheeersConfig,
  auth: Authentication,
): VueRouter {
  Vue.use(VueRouter);

  const router = new VueRouter({
    mode: 'history',
    base: config.urlPrefix,
    routes,
  });

  router.beforeEach((to, from, next) => {
    if (to.meta.noNeedLoggedIn) {
      next();
      return;
    }
    auth
      .isAllow(to.path)
      .then((/* isLoggedIn */) => {
        next();
      })
      .catch((e: AxiosError) => {
        switch (e.response.status) {
          case 403:
            next(false);
            break;
          case 401:
            if (to.path !== '/login') {
              next('/login');
            }
            break;
          default:
            next(false);
            break;
        }
      });
  });
  router.afterEach(({ name }) => {
    if (name) {
      window.document.title = `${config.appTitle} - ${name}`;
    } else {
      window.document.title = config.appTitle;
    }
  });
  return router;
}
